import classnames from 'classnames';

import styles from './EntryStatusItem.module.scss';

import { EntryStatus } from 'chaika-enums';

import { Icon, IconType } from '@components/Icon';

interface EntryStatusItemProps {
    status: EntryStatus;
    isSignedWithEDS?: boolean;
}

export function EntryStatusItem({ status, isSignedWithEDS }: EntryStatusItemProps) {
    let statusItem: React.ReactElement<any>;

    switch (status) {
        case EntryStatus.Archive: {
            statusItem = (
                <div className={styles.iconContainer}>
                    <Icon type={IconType.ARCHIVE_BOX} />
                </div>
            );
            break;
        }
        case EntryStatus.ReadyForDescribing: {
            statusItem = (
                <div className={styles.iconContainer}>
                    <Icon type={IconType.READY_FOR_DESCRIBING} />
                </div>
            );
            break;
        }
        default: {
            statusItem = (
                <div
                    className={classnames([
                        styles.circle,
                        status === EntryStatus.Signed ? styles.circle_signed : styles.circle_draft,
                    ])}
                />
            );
        }
    }

    return (
        <div className={styles.root}>
            {statusItem}
            {!!isSignedWithEDS && (
                <div className={styles.edsIcon}>
                    <Icon type={IconType.CHECK_REDESIGN} />
                </div>
            )}
        </div>
    );
}
